// extracted by mini-css-extract-plugin
export var currencyInput = "_ks-1";
export var currencySymbol = "_ks-0";